import { render, staticRenderFns } from "./TabHeader.vue?vue&type=template&id=1ac227f0&scoped=true&"
import script from "./TabHeader.vue?vue&type=script&lang=js&"
export * from "./TabHeader.vue?vue&type=script&lang=js&"
import style0 from "./TabHeader.vue?vue&type=style&index=0&id=1ac227f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac227f0",
  null
  
)

export default component.exports